import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { AfterViewInit, Component, Inject, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ChargingParkSubscriptionComponent } from '@components/manage/profile/charging-park-subscription/charging-park-subscription.component';
import { UserProfile } from '@dto/userProfile';
import { IEntity } from '@interfaces/entity';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'app-charging-park-subscription-dialog-content',
  templateUrl: './charging-park-subscription-dialog-content.component.html',
  styleUrls: ['./charging-park-subscription-dialog-content.component.scss']
})
export class ChargingParkSubscriptionDialogContentComponent extends AbstractDialogContent implements OnInit, AfterViewInit {

  public className = 'ChargingParkSubscriptionDialogContentComponent';
  
  @Input() private stripeAccountId: string;
  @ViewChild('chargingParkSubscriptionComponent') chargingParkSubscriptionComponent: ChargingParkSubscriptionComponent;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    public activeModal: NgbActiveModal,
    public formService: FormService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngAfterViewInit() {
    this.chargingParkSubscriptionComponent.parkOwnerStripeAccountId = this.stripeAccountId;
  }

  newEntityEvent(entity: IEntity) {
    this.activeModal.close();
  }
}